import React from "react";

// Structural rule from source (Feedback.jsx): only the elevated/exceptional
// state gets a colored pill — baseline state should render as plain muted
// text, not its own badge. success/warning/destructive triad reused for any
// approve/reject-style flow (ADMIN_DESIGN_SYSTEM.md "Badge / status pattern").
const TONES = {
  neutral: "bg-white border border-[#E5DFC8] text-hv-slate",
  success: "bg-hv-tealTint text-hv-teal",
  warning: "bg-hv-goldTint text-hv-navy",
  destructive: "bg-hv-coralTint text-hv-coral",
  primary: "bg-hv-coral text-white",
  accent: "bg-hv-tealTint text-hv-teal",
};

export default function AdminBadge({ tone = "neutral", uppercase, className = "", children }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 ${
        uppercase ? "text-[10px] uppercase tracking-wider font-bold" : "text-xs font-semibold"
      } ${TONES[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
